import pug from 'javascripts/core_post_webpack/sitewide_business_elements/navbar/templates/search_result.jst.pug';
window.JST = window.JST || {};
window.JST[
  'core_post_webpack/sitewide_business_elements/navbar/templates/search_result'
] = pug;
